"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var navigationStyles_1 = require("./navigationStyles");
var Routes_1 = require("../../../enum/Routes");
var Translation_1 = require("../Translation/Translation");
var ArrowBackIos_1 = require("@material-ui/icons/ArrowBackIos");
var clsx_1 = require("clsx");
var constants_1 = require("../../../../../../common/constants/constants");
var usePlatformConfig_1 = require("../../../react/usePlatformConfig");
var useGqlNav_1 = require("../../../../gql/common/hooks/useGqlNav");
var Navigation = function (_a) {
    var _b = _a.withIcon, withIcon = _b === void 0 ? true : _b, _c = _a.backTextClassName, backTextClassName = _c === void 0 ? '' : _c, _d = _a.backTextVariant, backTextVariant = _d === void 0 ? 'body1' : _d;
    var _e = usePlatformConfig_1.default().platformConfig.platformFeatures, isDealerEnabled = _e.isDealerEnabled, returnToConfiguratorFromPayment = _e.returnToConfiguratorFromPayment, isExtrasPageEnabled = _e.isExtrasPageEnabled;
    var _f = useGqlNav_1.useGqlNav(), location = _f.location, history = _f.history, configurationSourceUrl = _f.configurationSourceUrl;
    var style = navigationStyles_1.default();
    var navigateBack = react_1.useCallback(function () {
        var pathName = window.location.pathname.split('/');
        var paymentPath = window.location.pathname.includes(Routes_1.Routes.PAYMENT);
        if ((!isExtrasPageEnabled &&
            ((!isDealerEnabled && pathName.includes(constants_1.constants.REQUEST_QUOTE)) || pathName.includes(constants_1.constants.DEALER))) ||
            pathName.includes(constants_1.constants.EXTRAS)) {
            window.location.assign(configurationSourceUrl);
            return;
        }
        switch (pathName[pathName.length - 1]) {
            case Routes_1.Routes.PAYMENT.substr(1).split('/')[1]:
                if (returnToConfiguratorFromPayment) {
                    window.location.assign(configurationSourceUrl);
                    return;
                }
                history.replace(Routes_1.Routes.RESERVE_ONLINE + location.search);
                return;
            case Routes_1.Routes.RESERVE_ONLINE.substr(1):
                window.location.assign(configurationSourceUrl);
                return;
            default:
                return paymentPath ? null : history.goBack();
        }
    }, [history, configurationSourceUrl]);
    return (<core_1.Grid className={style.innerBackButtonContainer} item>
      {!!withIcon && <ArrowBackIos_1.default className={style.icon}/>}
      <core_1.Typography onClick={navigateBack} component="span" variant={backTextVariant} data-test="text:navigation:backButton" className={clsx_1.default([style.label, backTextClassName])}>
        <Translation_1.default id="trans__checkout__general__back_link"/>
      </core_1.Typography>
    </core_1.Grid>);
};
exports.default = Navigation;
